import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const LEASE_OPTIONS = {
  ROOT: `${PRIVATE_ROOT}/lease-options`,
  ADD_REQUEST_RENEWAL: `${PRIVATE_ROOT}/lease-options/add-renewal-request`,
}
